module.exports = __webpack_public_path__ + "static/media/nike-logo.47b5b690.png";